import styled from 'styled-components';

export const CustomScoreWrapper = styled.div<{ disabled: boolean }>`
  width: 100%;
  & .control-select-filter-inner {
    background: ${({ disabled }) => (disabled ? '#f8f8f8' : 'none')};
  }
`;
